import api from "../store/services/api";

export const getPaymentMethods = () =>
  api.get("/delivery-center/payment-methods/");

export const createPaymentMethod = (paymentMethod) =>
  api.post("/delivery-center/payment-methods/", paymentMethod, {
    headers: { "Content-Type": "application/json" },
  });

export const editPaymentMethod = (paymentMethod, paymentMethodId) =>
  api.put(
    `/delivery-center/payment-methods/?opid=${paymentMethodId}`,
    paymentMethod,
    {
      headers: { "Content-Type": "application/json" },
    }
  );

export const deletePaymentMethod = (paymentMethodId) =>
  api.delete(`/delivery-center/payment-methods/?opid=${paymentMethodId}`);

export const createOrderPaymentMethod = (orderPaymentMethod) =>
  api.post("/orders/payment-methods/", orderPaymentMethod, {
    headers: { "Content-Type": "application/json" },
  });

export const deleteOrderPaymentMethod = (payment_method) =>
  api.delete(
    `/orders/payment-methods/?opid=${payment_method.id}`,
    payment_method
  );

const PaymentMethodsService = {
  getPaymentMethods,
  createPaymentMethod,
  editPaymentMethod,
  deletePaymentMethod,
  createOrderPaymentMethod,
  deleteOrderPaymentMethod,
};

export default PaymentMethodsService;
